import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const GmailIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#fff"
      d="M1 5.1v1.63l1.88 1.82L5.09 9.8l.41-2.76-.4-2.56-1.15-.86A1.84 1.84 0 0 0 1 5.09M14.9 4.48l-.4 2.6.4 2.72 2.02-1L19 6.73V5.09a1.84 1.84 0 0 0-2.95-1.47z"
    />
    <path
      fill="#fff"
      d="M2.23 16.75h2.86V9.8L1 6.73v8.8c0 .67.55 1.22 1.23 1.22M14.9 16.75h2.87c.68 0 1.23-.55 1.23-1.23v-8.8L14.9 9.8zM10 8.16 5.1 4.48V9.8l4.9 3.68 4.9-3.68V4.48z"
    />
  </svg>
);
